const alerts = {
    'alert.whoops': 'Something went wrong',
    'alert.whoops.message.password_mismatch': 'The passwords do not match!',
    'alert.whoops.message.password_required': 'The password field is required!',
    'alert.whoops.message.invalid_email': 'A valid e-mail address has not been entered, please try again',
    'alert.whoops.message.preferred_language.required': 'Preffered language is a required field',
    'alert.whoops.message.company.required': 'Company is a required field',

    'alert.whoops.message.firstname.required': 'Firstname is a required field',
    'alert.whoops.message.lastname.required': 'Lastname is a required field',
    'alert.whoops.message.email.required': 'Email is a required field',
    'alert.whoops.message.email.invalid': 'The email is not valid',
    'alert.whoops.message.subscription.required': 'Selecting a subscription is required',

    'alert.success': 'Yeah!',
    'alert.success.message.saved': 'The changes have been saved successfully.',
    'alert.success.message.registered': 'Registration is successful, you will be redirected to the login page',
    'alert.success.message.register_client': 'Registration is successful, you will receive an email to activate your account',
    'alert.success.message.subscribed': 'You have successfully subscribed to the chosen subscription, enjoy!',
    'alert.success.message.synchronisation_started': 'The synchronisation has been successfully started',

    'alert.confirm.delete': 'Are you sure you want to delete this item?',
    'alert.confirm.disable': 'Are you sure you want to disable this item?',
    'alert.confirm.enable': 'Are you sure you want to enable this item?',
    'alert.confirm.allow': 'Are you sure your want to allow this?',
    'alert.confirm.disallow': 'Are you sure your want to disallow this?',
    'alert.confirm.invitation.resend': 'Are you sure you want to resend the invitation?',
    'alert.confirm.start_synchronisation': 'Are you sure you want to start the synchronisation?',
    'alert.confirm.start_dryrun': 'Are you sure you want to start the dry run synchronisation?',
    'alert.confirm.active_start_synchronisation': 'Warning! the synchronisation is still going! Are you sure you want to start the synchronisation again?',
    'alert.confirm.active_start_dryrun': 'Warning! the synchronisation is still going! Are you sure you want to start the dry run synchronisation again?',
    'alert.confirm.delete.unsaved.changes': 'Are you sure you want to delete this item? All unsaved changes will be lost.',

    'alert.title.invitation.send': 'Invitation sent!',
    'alert.title.invitation.resend': 'Invitation sent again!',

    'alert.combine.brands.magento': 'Magento doesn\'t use brands. You could create an attribute within Magento and assign it within the connector attributes tab.',
    'alert.combine.brands.woocommerce': 'WooCommerce doesn\'t use brands. You could create an attribute within WooCommerce and assign it within the connector attributes tab.',
    'alert.combine.customergroups.woocommerce': 'WooCommerce does not have customer groups, but you can configure a discount here.',
    'alert.combine.languages.woocommerce': 'WooCommerce does not have languages.',
    'alert.pricing.not.needed': 'Price margin is only configurable when the \'price\' is not combined in the feed.',

    'alert.title.succes': 'Succes!',
    'alert.confirm.client.change': 'Are you sure that you want to activate/deactivate this client?',

    'alert.subscriptions.custom_subscription_requested': 'Your request for a custom subscription is requested. You\'ll also receive a confirmation email within a few minutes.',
    'alert.subscriptions.has_custom_subscription_options': 'There are one or more custom subscriptions approved in your account. You can recognize these options by the green color. Pick the desired (custom) subscription and press "Continue to payment" to pay and activate your subscription.',
};

export default alerts;
